import {Component, OnInit, ChangeDetectionStrategy, Input, Output} from '@angular/core';

import {UnitAchLimits} from '../../../models/unit-bank-account/UnitAchLimits.model';
import { UnitAccountLimits } from 'src/app/shared/models/unit-bank-account/UnitAccountLimits.model';
import { UnitWireLimits } from 'src/app/shared/models/unit-bank-account/UnitWireLimits.model';

@Component({
  selector: 'terra-bank-account-limits',
  templateUrl: './bank-account-limits.component.html',
  styleUrls: ['./bank-account-limits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountLimitsComponent implements OnInit {
  @Input() accountLimits: UnitAccountLimits;
  @Input() displayDailyDebit = true;
  @Input() displayDailyCredit = true;
  @Input() displayMonthlyDebit = true;
  @Input() displayMonthlyCredit = true;

  achLimit: UnitAchLimits;
  wireLimit: UnitWireLimits;

  constructor(

  ) { }

  ngOnInit(): void {
    this.achLimit = this.accountLimits.achLimits;
    this.wireLimit = this.accountLimits.wireLimits;
  }

  get displayAchSection(): boolean {
    return this.displayDailyCredit || this.displayDailyDebit || this.displayMonthlyDebit || this.displayMonthlyCredit;
  }
}
